import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import LmsBillingTable from "@/components/lms/lmsBillingTable";
import { LMS_BILLING_PERMISSION } from "@/components/lms/lms.utils";
import { RootState } from "@/components/state/store";
import { usePageHeading } from "@/helper/customHooks/usePageHeading";

export default function LmsBilling() {
  const { t } = useTranslation();
  const permissions = useSelector(
    (state: RootState) => state.login.permissions,
  );
  const subdomain = window.location.hostname.split(".")[0];
  usePageHeading(`${t("lms_product_name")} ${t("lms_overview")}`);

  if (
    subdomain !== "admin" ||
    !permissions.includes(LMS_BILLING_PERMISSION)
  ) {
    return <Navigate to="/" replace />;
  }

  return <LmsBillingTable />;
}
